import { PROYECT, api_get } from "services/api";

import {
  startRequest,
  stopRequest,
  setSnackbar,
  startRequestComp,
  stopRequestComp,
} from "redux/actions/search/searchActions";

import { PAYMENTS_TYPES } from "redux/reducers/buildings/payments/paymentsTypes";
import { addLabelArray } from "helpers/addLabelArray";
import { normalizedPayment } from "helpers/normalizedPayment";

const {
  CLEAR_PAYMENTS,
  SET_ACCOUNTS,
  SET_PAYMENTS,
  SET_SELECTED_ACCOUNT,
  HANDLE_PAYMENTS_INPUTS,
} = PAYMENTS_TYPES;

const getUrlAccounts = stationID =>
  `${process.env.REACT_APP_URL}${PROYECT}/buildings/balances/stations/${stationID}`;
const getUrlPayments = accountID =>
  `${process.env.REACT_APP_URL}${PROYECT}/buildings/balances/${accountID}/movements`;

export function clearPayments() {
  return {
    type: CLEAR_PAYMENTS
  };
}

export function selectAccount(account) {
  return {
    type: SET_SELECTED_ACCOUNT,
    payload: account
  };
}

export const handlePaymentsInputsAction = (key, value) => async dispatch => {
  try {
    if (key === "station" && value?.id) {
      await dispatch(fetchAccounts(value?.id));
    }
    else if (key === "station" && !value?.id) {
      dispatch({ type: SET_ACCOUNTS, payload: { accounts: [] } });
      dispatch(selectAccount(null));
    }
    dispatch({ type: HANDLE_PAYMENTS_INPUTS, payload: { key, value } });
  } catch (error) {
    dispatch({ type: HANDLE_PAYMENTS_INPUTS, payload: { key, value: null } });
    dispatch(setSnackbar(error));
  }
};

export const fetchAccounts = (idStation = null) => async dispatch => {
  dispatch(startRequest("fetchAccounts"));
  try {
    const accounts = await api_get(getUrlAccounts(idStation));
    const newAccounts = addLabelArray(accounts, "name");

    dispatch({
      type: SET_ACCOUNTS,
      payload: {
        accounts: newAccounts
      }
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequest("fetchAccounts"));
};

export const fetchPayments = (routeCycleID = null) => async dispatch => {
  dispatch(startRequestComp("fetchPayments"));

  try {
    const payments = await api_get(getUrlPayments(routeCycleID));

    dispatch({
      type: SET_PAYMENTS,
      payload: {
        payments: normalizedPayment(payments)
      }
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp("fetchPayments"));
};
